import { LOAN_BLOTTER_PREFIX } from '@src/containers/Blotters/OTC/Loans/tokens';
import { shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateLegacyTabsIntoTradingBlotterPanels } from '../blotterTabsMigrationHelpers';
import type { AppConfigStateWithLegacyLayoutConfigs } from '../legacyLayoutConfigs.types';

/** Moves legacy loans tabs into loans blotter panel params. */
export function migrateLoansBlotterTabsToPanelParams(initialConfig: unknown) {
  const config = initialConfig as AppConfigStateWithLegacyLayoutConfigs;
  if (!shouldRunBlotterTabsMigration(config)) {
    return;
  }
  const legacyLoanTabs = config.tabs?.[LOAN_BLOTTER_PREFIX];
  if (legacyLoanTabs == null) {
    return;
  }

  migrateLegacyTabsIntoTradingBlotterPanels(config, {
    legacyTabs: legacyLoanTabs,
    blotterType: 'loans',
  });
}
